import { render, staticRenderFns } from "./VoyageElement.vue?vue&type=template&id=ffc594b4&scoped=true&"
import script from "./VoyageElement.vue?vue&type=script&lang=js&"
export * from "./VoyageElement.vue?vue&type=script&lang=js&"
import style0 from "./VoyageElement.vue?vue&type=style&index=0&id=ffc594b4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffc594b4",
  null
  
)

export default component.exports